import PhotoVerificationGroup from './PhotoVerificationGroup';

export default PhotoVerificationGroup;
